import {navigateTo} from '@typed-router';
import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, useGuestHost, useExtractQueryParameters} from '#imports';

import {getMaybeRedirection} from '~/middleware/redirect/redirection';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
    const host = useGuestHost();
    const queryParams = useExtractQueryParameters(to) || '';

    const maybeRedirection = getMaybeRedirection(to, host, queryParams);
    if (maybeRedirection.redirect && maybeRedirection.url) {
        return navigateTo(maybeRedirection.url, {external: true});
    }
});
